import { ApolloError, useMutation } from '@apollo/client';
import { useGetSortedCommentsQuery } from './useGetSortedCommentsQuery';
import { getLikesMutationOptions } from '../services/getLikesMutationOptions';
import { addLikeMutation, removeLikeMutation } from '../mutations/updateLikes';
import { TCommentProps } from '../CommentsList';
import { mapT2Comments } from '../services/t2Comments';

type TUseGetT2Comments = {
  articleId: string;
  userId?: string;
  loadingAuthenticatedUserStatus: boolean;
};

export const useGetT2Comments = ({
  articleId,
  userId,
  loadingAuthenticatedUserStatus,
}: TUseGetT2Comments): {
  t2CommentsLoading: boolean;
  t2CommentsError: ApolloError | undefined;
  t2Comments: TCommentProps[] | undefined;
  getT2Comments: Function;
  shouldFetchT2Comments: boolean;
} => {
  const [getSortedComments, { data, loading, error }] = useGetSortedCommentsQuery({
    articleId,
    userId,
  });

  const mutationOptions = getLikesMutationOptions(articleId, userId);
  const [addLike] = useMutation(addLikeMutation, mutationOptions);
  const [removeLike] = useMutation(removeLikeMutation, mutationOptions);
  const shouldFetchT2Comments = !loadingAuthenticatedUserStatus;

  return {
    t2CommentsLoading: loading,
    t2CommentsError: error,
    t2Comments: mapT2Comments(data?.sortedCommentsForArticle, userId, addLike, removeLike),
    getT2Comments: getSortedComments,
    shouldFetchT2Comments,
  };
};
